import Vue from 'vue'
import Vuex from 'vuex'
import player from './player'
import alerts from './alerts'
import create from './create'
import edit from './edit'
import preview from './preview'
import dialogues from './dialogues'
import play from './PlayModes/play'
import learn from './PlayModes/learn'
import record from './PlayModes/record'
import hub from './PlayModes/hub'
import watch from './watch'
import recording from './recording'
import main from './main'
import tutorials from './tutorials'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    player,
    alerts,
    create,
    edit,
    preview,
    dialogues,
    play,
    learn,
    record,
    hub,
    watch,
    recording,
    main,
    tutorials
  }
})
